export enum ApprovalStatusEnum {
    Internal = 0,
    Pending = 1,
    Public = 2
}
